import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CustomerBoatRequestDialogComponent } from './customer-boat-request-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CustomerBoatRequestDialogService {
  constructor(private dialog: MatDialog) {}

  public open(charterId: number): Observable<boolean> {
    let dialogRef: MatDialogRef<CustomerBoatRequestDialogComponent>;
    dialogRef = this.dialog.open(CustomerBoatRequestDialogComponent, {
      maxWidth: '90vw',
      data: {
        charterId: charterId,
      },
    });
    return dialogRef.afterClosed();
  }
}
